import { Pagination } from '../models';

export const PAGINATION_DEFAULT_PAGE_SIZE = 10;
export const PAGINATION_DEFAULT_MAX_PAGES_TO_SHOW = 10;
export const PAGINATION_DEFAULT_TOTAL_ITEMS = 10;
export const DEFAULT_PAGINATION: Pagination = {
  page: 1,
  pageSize: PAGINATION_DEFAULT_PAGE_SIZE,
};
export const DEFAULT_DATE_HOURS = 24;
export enum FEATURE_FLAG {
  LICENSING = 'hrt_insightpartner-bluredcare.licensing',
  REMOTE_ACCESS = 'hrt_insightpartner-bluredcare.remote_access',
}
